export enum DONATIONS {
  ROUND_UP = 'Round UP',
}
